import React, { useEffect, useState } from 'react';
import Pagination from "react-js-pagination";
import { isMobile } from "react-device-detect";
import Select from 'react-dropdown-select';
import CommonImage from '../../CommonComponent/CommonImage';


export default class FavoriteNames extends React.Component {
    constructor() {
        super();
        this.state = {
            favNames: [],
            currentPage: 1,
            itemsCountPerPage: 10,
            ddstate: 'dclose',
            pagesize: {
                optionvalue: '',
                placeholder: ''
            }
            // pagination: '',
            // itemsCountPerPage: 10
        };
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        this.setState({
            favNames: this.props.favNames
        })
        let pageperitem = 10
        let placeholder = this.props.pageSize && this.props.pageSize !== null && this.props.pageSize.map(data => parseInt(data.fields.key.value) === parseInt(pageperitem) && data.fields.name.value)
        let optionvalue = this.props.pageSize && this.props.pageSize !== null && this.props.pageSize.map(data => ({ value: data.fields.key.value, label: data.fields.name.value }))

        this.setState({
            pagesize: {
                optionvalue: optionvalue,
                placeholder: placeholder.filter(res => res !== false && res)
            }
        })
    }

    componentDidUpdate(nextProps) {
        // let { counter } = this.props.counter
        if (nextProps.counter !== this.props.counter) {
            this.setState(() => {
                return {
                    favNames: this.props.favNames
                }

            }, () => {

            })
            if (this.props.favNames.length % this.state.itemsCountPerPage === 0) {
                this.setState({
                    currentPage: this.state.currentPage - 1
                })
            }

        }


    }

    handleClick(event) {
        // this.setState({
        //     currentPage: Number(event.target.id)
        // });
        this.setState({
            currentPage: Number(event)
        });
    }

    removeFromFav(data) {
        this.props.removeFromFav(data)
    }

    paginate = (pageNumber) => {
        // Highlighting current page
        // this.setState({
        //     pagination: pageNumber
        // })
        // setting currentPageNumber and getting particular data for that page only
        this.setState({
            currentPage: Number(pageNumber)
        });
        // this.handleClick(pageNumber)
    }

    onChange = (result) => {
        // onchange of total element shown, setting page numer default to 1
        this.setState({
            itemsCountPerPage: Number(result[0].value),
            currentPage: 1
        })
    }

    render() {
        const { favNames, currentPage, itemsCountPerPage } = this.state;

        // Logic for displaying current page favorite Names
        const indexOfLastNames = currentPage * itemsCountPerPage;
        const indexOfFirstNames = indexOfLastNames - itemsCountPerPage;
        const currentNames = favNames.slice(indexOfFirstNames, indexOfLastNames);

        const renderFavNames = currentNames.map((data, index) => (
            <tr key={index} className={(index % 2 === 0) ? '' : 'grey-background'}>
                <td className="nameResultTableContent">{data.firstName}
                    {data.middleName && <span>{' ' + data.middleName}</span>}
                </td>
                <td className="nameResultTableContent">
                    <div className="genderIcon">
                        <CommonImage imageIcon={data.genderImage.src} />
                    </div>
                </td>
                <td className="nameResultTableContent">{data.origin}</td>
                <td className="nameResultTableContent">{data.meaning}</td>
                <td className="nameResultTableContent" onClick={() => this.removeFromFav(data)}>
                    <div className="favIcon">
                    <span className="fa fa-trash"></span>
                    </div>

                </td>
            </tr>
        ))

        // Logic for displaying page numbers
        // const pageNumbers = [];
        // for (let i = 1; i <= Math.ceil(favNames.length / itemsCountPerPage); i++) {
        //     pageNumbers.push(i);
        // }

        // const renderPageNumbers = pageNumbers.map(number => {
        //     return (
        //         <li
        //             key={number}
        //             id={number}
        //             onClick={this.handleClick}
        //         >
        //             {number}
        //         </li>
        //     );
        // });

        return (
            <>
                <div>
                    {!isMobile && <table className="nameResultTable">
                        <thead>
                            <tr>
                                <th className="nameResultTableHeading">{this.props.componentData.nameColumnLabel.value}</th>
                                <th className="nameResultTableHeading">{this.props.componentData.genderColumnLabel.value}</th>
                                <th className="nameResultTableHeading">{this.props.componentData.originColumnLabel.value}</th>
                                <th className="nameResultTableHeading">{this.props.componentData.meaningColumnLabel.value}</th>
                                <th className="nameResultTableHeading favourite"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {renderFavNames}
                        </tbody>
                    </table>}

                    {isMobile &&
                        <div>
                            <div>
                                {currentNames.map((data, index) => (
                                    <div key={index} className={(index % 2 === 0) ? '' : 'grey-background'}>
                                        {/* <td className="nameResultTableContent">{data.firstName}</td> */}
                                        <div className="container-card-tile">

                                            <div className="card">
                                                {/* <img className="card-img-top" src="img_avatar1.png" alt="Card image"/> */}
                                                <div className="card-body">
                                                    <div className="card-header-top">
                                                        <div className="card-header-right">
                                                            <div className="genderIcon">
                                                                <CommonImage imageIcon={data.genderImage.src} />
                                                            </div>
                                                            <div className="babyNameText">
                                                                <p className="babyFirstNameText">{data.firstName}
                                                                {data.middleName && <span className="middleNameText">{' ' + data.middleName}</span>}
                                                                </p>
                                                               
                                                            </div>
                                                        </div>
                                                        <div className="card-header-left">
                                                            <div className="favIcon" onClick={() => this.removeFromFav(data)}>
                                                              
                                                            <span className="fa fa-trash"></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-body-content">
                                                        <div className="card-body-content-detail">
                                                            <p className="content-label">{this.props.componentData.originColumnLabel.value}</p>
                                                            <p className="content-label-text">{data.origin}</p>
                                                        </div>
                                                        <div className="card-body-content-detail">
                                                            <p className="content-label">{this.props.componentData.meaningColumnLabel.value}</p>
                                                            <p className="content-label-text">{data.meaning}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                                )
                                }
                            </div>
                        </div>
                    }

                    <div className="paginate-blk">
                        {this.state.pagesize.optionvalue && this.state.favNames.length > Number(this.state.pagesize.optionvalue[0].value) && <Select
                            className={this.state.ddstate}
                            onChange={this.onChange}
                            placeholder={this.state.pagesize.placeholder}
                            options={this.state.pagesize.optionvalue}
                            separator={false}
                            dropdownHandle={false}
                            onDropdownOpen={() => this.setState({ ddstate: 'dopen' })}
                            onDropdownClose={() => this.setState({ ddstate: 'dclose' })}
                            dropdownPosition="auto"
                        />}
                        {this.state.favNames.length > this.state.itemsCountPerPage && <Pagination
                            hideFirstLastPages
                            hideDisabled
                            activePage={this.state.currentPage}
                            itemsCountPerPage={this.state.itemsCountPerPage}
                            totalItemsCount={this.state.favNames.length}
                            onChange={this.paginate}
                            pageRangeDisplayed={isMobile ? 3 : 4}
                            prevPageText={<i className="fa fa-angle-left" aria-hidden="true"></i>}
                            nextPageText={<i className="fa fa-angle-right" aria-hidden="true"></i>}
                        />}
                    </div>
                </div>
            </>
        );
    }
}